import React, { Component } from "react";
import { withRouter } from "./withRouter";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box, Stack, Select,Grid,
    FormControl, InputLabel, MenuItem,TextField
 } from "@mui/material";
import DemogVoteAndIssues from "./DemogVoteAndIssues"
import { rowsFromTable } from "./utils/arrowUtils";
import { PARTY_COLOURS as _PARTY_COLOURS } from "./constants/partyConfig";

const PARTY_COLOURS = { ..._PARTY_COLOURS, coalition: "#13265C" };




const PARTY_NAME = {
    act:"ACT",
  green:"Green",
  lab:"Labour",
  nat:"National",
  nzf:"NZF",
  tpm:"TPM",
  coalition:"Coalition",
  oth:"Other",
}


class VotersDemographics extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenDemog:"Gender",
      scatterDemogsRows:null
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("constituency", null, true);
    this.fetchDemogsForScatter()
  };
  run();
}

 
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"){
          keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "oth_pred_n",
                    "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
                    "gov_good_n",
                    "gov_bad_n",
                    "gov_dn_n",
                    "turnout_1_p"
                  ]  
    }else{
    keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "oth_pred_n",
                    "turnout_1_p"
                  ]
                }

     let turnout_weight
    turnout_weight = "turnout_1_n"
    const body = {
      groupKeys: keysBody,
      filters:[],
      constCode: constCode,
    turnout_weight: turnout_weight

    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }


  //main function that grabs data
    fetchDemogsForScatter = async () => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;



    const body = {
      table: "demogs_scatter"
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/fulltable_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
          this.setState(
             { scatterDemogsRows: rowsMain })
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ scatterDemogsRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }

    
  handlechosenDemogChange     = (val) => this.setState({ chosenDemog: val });
    

  render() {
  return (
  <Box
    sx={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={(theme) => ({
        px: 3,
        py: 2,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        flexShrink: 0,
      })}
    >
      <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Voter Breakdown
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Select a group to explore the breakdown
          </Typography>
        </Box>

        <TextField
          select
          label="Demographic"
          size="small"
          value={this.state.chosenDemog}
          onChange={(e) => this.handlechosenDemogChange?.(e.target.value)}
          sx={{ ml: 3, minWidth: 180 }}
        >
          <MenuItem value="Gender">Gender</MenuItem>
          <MenuItem value="Age">Age</MenuItem>
          <MenuItem value="Ethnicity">Ethnicity</MenuItem>
          {/* <MenuItem value="Vote 2023">Vote 2023</MenuItem> */}
        </TextField>
      </Stack>
    </Box>

    <Grid
      container
      sx={{
        width: '100%',
        alignItems: 'center',
        px: 2,
        py: 1.5,
        flexShrink: 0,
      }}
    >
      <Grid item width="50%">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            Predicted vote share by demographic
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {Object.keys(PARTY_NAME).map((party) => (
              <Box
                key={party}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: PARTY_COLOURS[party],
                  }}
                />
                <Typography sx={{ fontSize: 12 }}>
                  {PARTY_NAME[party]}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Grid>

      <Grid item width="50%">
        <Stack spacing={1}>
          <Typography variant="h6" fontWeight="bold">
            Top issues among voter group
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Box sx={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>1</Box>
            <Box sx={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>2</Box>
            <Box sx={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>3</Box>
          </Box>
        </Stack>
      </Grid>
    </Grid>

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      <DemogVoteAndIssues
        scatterDemogsRows={this.state.scatterDemogsRows}
        chosenDemog={this.state.chosenDemog}
      />
    </Box>
  </Box>
);
}


  }

export default withRouter(VotersDemographics);